import { useEffect, useState } from 'react';

import type { Item, Props } from './types';

const useData = ({ isLoading, items }: Props) => {
    const [isListLoading, setIsListLoading] = useState(isLoading);
    const [filteredItems, setFilteredItems] = useState<Item[]>([]);

    const handleSearchChange = (filtered: Item[]) => {
        setFilteredItems(filtered);
    };

    const hasNoItems = filteredItems.length === 0 && items.length === 0;
    const displayItems = filteredItems.length > 0 ? filteredItems : items;

    useEffect(() => {
        setIsListLoading(isLoading);
    }, [isLoading]);

    return {
        displayItems,
        handleSearchChange,
        hasNoItems,
        isListLoading
    };
};

export default useData;
